// src/pages/Training.jsx
import React, { useState, useEffect } from "react";
import { ChatAPI } from "../api/chatApi";

import * as Constants from "./../store/index";
import * as Util from "../data/General";

/* ---------------- BASE ---------------- */

const BASE_QUESTIONS = [
  "Tiempo y proceso de entrega",
  "Costos de envío",
  "Seguimiento de pedidos",
  "Promociones y descuentos",
  "Medios de pago",
  "Proceso de devoluciones",
  "Cambios de productos",
  "Horarios de atención",
  "Facturación",
  "Garantía de productos",
];

const normalize = (text = "") =>
  text.toLowerCase().replace(/[¿?]/g, "").trim();

/* ---------------- COMPONENT ---------------- */

export default function ConfigChat() {
  const store = Util.getAdminShop();
  const storeId = store.id;

  const [questions, setQuestions] = useState(BASE_QUESTIONS);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  /* --------- CARGA INICIAL --------- */
  useEffect(() => {
    async function loadTraining() {
      try {
        const store = await ChatAPI.getStoreExamples(storeId);

        if (!store.training_examples) {
          setLoading(false);
          return;
        }

        const examples = JSON.parse(store.training_examples);

        const guided = {};
        const dynamicQuestions = [...BASE_QUESTIONS];

        examples.forEach((ex) => {
          const cleanQuestion = ex.user.replace(/[¿?]/g, "");
          const normalized = normalize(cleanQuestion);

          const exists = dynamicQuestions.find(
            (q) => normalize(q) === normalized
          );

          if (!exists) {
            dynamicQuestions.push(cleanQuestion);
          }

          guided[cleanQuestion] = ex.assistant;
        });

        setQuestions(dynamicQuestions);
        setAnswers(guided);
      } catch (e) {
        console.error("Error cargando entrenamiento", e);
      } finally {
        setLoading(false);
      }
    }

    loadTraining();
  }, [storeId]);

  /* --------- GUARDAR --------- */
  const saveTraining = async () => {
    const examples = [];

    questions.forEach((q) => {
      if (q.trim() && answers[q] && answers[q].trim()) {
        examples.push({
          user: `¿${q}?`,
          assistant: answers[q],
        });
      }
    });

    if (!examples.length) {
      alert("No hay información para guardar");
      return;
    }

    setSaving(true);

    await ChatAPI.saveExamples(storeId, examples);

    Util.createChatIA(Constants.getAccessTokenStore());

    setTimeout(() => {
      setSaving(false);
      alert("Entrenamiento guardado correctamente");
    }, 2000);
  };

  /* --------- UI --------- */

  if (loading) {
    return <p>Cargando entrenamiento…</p>;
  }

  return (
    <div className="training-container">
      
      <p className="training-intro">
        Agrega preguntas y respuestas como si fueras tu tienda.
        Lia usará esta información para responder automáticamente.
      </p>

      

      <div className="">
        <div>
          {questions.map((q, index) => {
            const isBase = index < BASE_QUESTIONS.length;

            return (
              <div key={index} className="training-block">
                <input
                  type="text"
                  value={q}
                  disabled={isBase}
                  placeholder="Pregunta del cliente"
                  onChange={(e) => {
                    const copy = [...questions];
                    copy[index] = e.target.value;
                    setQuestions(copy);
                    setAnswers({ ...answers, [e.target.value]: answers[q] || "" })
                  }}
                />

                <textarea
                  rows={3}
                  value={answers[q] || ""}
                  placeholder="Respuesta que daría tu tienda"
                  onChange={(e) => {
                    setAnswers({ ...answers, [q]: e.target.value })
                  }
                  }
                />

                {!isBase && (
                  <button
                    type="button"
                    className="remove-btn"
                    onClick={() => {
                      const copyQ = [...questions];
                      const removed = copyQ[index];
                      copyQ.splice(index, 1);

                      const copyA = { ...answers };
                      delete copyA[removed];

                      setQuestions(copyQ);
                      setAnswers(copyA);
                    }}
                  >
                    Eliminar
                  </button>
                )}

                
              </div>
            );
          })}
          <button
            type="button"
            className="add-btn"
            onClick={() => setQuestions([...questions, ""])}
          >
            + Agregar pregunta
          </button>
        </div>
      </div>

      <button
        className="save-btn"
        onClick={saveTraining}
        disabled={saving}
      >
        {saving ? "Guardando…" : "Guardar entrenamiento"}
      </button>
    </div>
  );
}
